const Medical = () => import(/* webpackChunkName: "pasienmobilemedical" */ '@/views/private/mobile/medical/Medical.vue')
const record = () => import(/* webpackChunkName: "pasienmobilemedicalrecord" */ '@/components/mobile/medical/Record.vue')
const ANC = () => import(/* webpackChunkName: "pasienmobilemedicalanc" */ '@/components/mobile/medical/ANC.vue')
const kesehatan = () => import(/* webpackChunkName: "pasienmobilemedicalkesehatan" */ '@/components/mobile/medical/Kesehatan.vue')
const Galery = () => import(/* webpackChunkName: "pasienmobilemedicalgallery" */ '@/components/mobile/medical/Galery.vue')
const INC = () => import(/* webpackChunkName: "pasienmobilemedicalinc" */ '@/components/mobile/medical/INC.vue')
const Yoga = () => import(/* webpackChunkName: "pasienmobilemedicalyoga" */ '@/components/mobile/medical/Yoga.vue')
const Kontrasepsi = () => import(/* webpackChunkName: "pasienmobilemedicalkontrasepsi" */ '@/components/mobile/medical/Kontrasepsi.vue')
const Promil = () => import(/* webpackChunkName: "pasienmobilemedicalpromil" */ '@/components/mobile/medical/Promil.vue')
const BayiAnak = () => import(/* webpackChunkName: "pasienmobilemedicalbayianak" */ '@/components/mobile/medical/BayiAnak.vue')
const Konsultasi = () => import(/* webpackChunkName: "pasienmobilemedicalkonsultasi" */ '@/components/mobile/medical/Konsultasi.vue')
const Umum = () => import(/* webpackChunkName: "pasienmobilemedicalumum" */ '@/components/mobile/medical/Umum.vue')
const EPINO = () => import(/* webpackChunkName: "pasienmobilemedicalepino" */ '@/components/mobile/medical/EPINO.vue')
const Massage = () => import(/* webpackChunkName: "pasienmobilemedicalmassage" */ '@/components/mobile/medical/Massage.vue')
const BabyMassageSpa = () => import(/* webpackChunkName: "pasienmobilemedicalbabymassagespa" */ '@/components/mobile/medical/BabyMassageSpa.vue')
const LatihanNafas = () => import(/* webpackChunkName: "pasienmobilemedicallatihannafas" */ '@/components/mobile/medical/LatihanNafas.vue')
const Hipnoterapi = () => import(/* webpackChunkName: "pasienmobilemedicalhipnoterapi" */ '@/components/mobile/medical/Hipnoterapi.vue')
const Akupuntur = () => import(/* webpackChunkName: "pasienmobilemedicalakupuntur" */ '@/components/mobile/medical/Akupuntur.vue')
const BirthPlan = () => import(/* webpackChunkName: "pasienmobilemedicalbirthplan" */ '@/components/mobile/medical/BirthPlan.vue')

const routes = [
  {
    path: "/mobile/patient/medical",
    name: "patient medical",
    component: Medical,
    meta: {
      title: "Data Pasien"
    },
    children: [
      {
        path: '/mobile/patient/medical/record/:id',
        name: ' patient medical record',
        component: record,
        meta: {
          title: "Form Data Riwayat Kunjungan"
        }
      },
      {
        path: '/mobile/patient/medical/ANC/:id',
        name: ' patient medical ANC',
        component: ANC,
        meta: {
          title: "Form Data ANC"
        }
      },
      {
        path: '/mobile/patient/medical/galery/:id',
        name: ' patient medical galery',
        component: Galery,
        meta: {
          title: "Data Galery Layanan"
        }
      },
      {
        path: '/mobile/patient/medical/kesehatan-kehamilan/:id',
        name: ' patient medical kesehatan kehamilan',
        component: kesehatan,
        meta: {
          title: "Data kesehatan & kehamilan"
        }
      },
      {
        path: '/mobile/patient/medical/INC/:id',
        name: ' patient medical INC',
        component: INC,
        meta: {
          title: "Form Data INC"
        }
      },
      {
        path: '/mobile/patient/medical/Yoga/:id',
        name: ' patient medical Yoga',
        component: Yoga,
        meta: {
          title: "Form Data Yoga"
        }
      },
      {
        path: '/mobile/patient/medical/Kontrasepsi/:id',
        name: ' patient medical Kontrasepsi',
        component: Kontrasepsi,
        meta: {
          title: "Form Data Kontrasepsi"
        }
      },
      {
        path: '/mobile/patient/medical/Promil/:id',
        name: ' patient medical Promil',
        component: Promil,
        meta: {
          title: "Form Data Promil"
        }
      },
      {
        path: '/mobile/patient/medical/Bayi-Anak/:id',
        name: ' patient medical BayiAnak',
        component: BayiAnak,
        meta: {
          title: "Form Data Bayi & Anak"
        }
      },
      {
        path: '/mobile/patient/medical/Konsultasi/:id',
        name: ' patient medical Konsultasi',
        component: Konsultasi,
        meta: {
          title: "Form Data Konsultasi"
        }
      },
      {
        path: '/mobile/patient/medical/Umum/:id',
        name: ' patient medical Umum',
        component: Umum,
        meta: {
          title: "Form Data Umum"
        }
      },
      {
        path: '/mobile/patient/medical/EPINO/:id',
        name: ' patient medical EPINO',
        component: EPINO,
        meta: {
          title: "Form Data EPINO"
        }
      },
      {
        path: '/mobile/patient/medical/Massage/:id',
        name: ' patient medical Massage',
        component: Massage,
        meta: {
          title: "Form Data Massage"
        }
      },
      {
        path: '/mobile/patient/medical/Baby-Massage-Spa/:id',
        name: ' patient medical BabyMassageSpa',
        component: BabyMassageSpa,
        meta: {
          title: "Form Data Baby Massage Spa"
        }
      },
      {
        path: '/mobile/patient/medical/Latihan-Nafas/:id',
        name: ' patient medical LatihanNafas',
        component: LatihanNafas,
        meta: {
          title: "Form Data Latihan Nafas"
        }
      },
      {
        path: '/mobile/patient/medical/Hipnoterapi/:id',
        name: ' patient medical Hipnoterapi',
        component: Hipnoterapi,
        meta: {
          title: "Form Data Hipnoterapi"
        }
      },
      {
        path: '/mobile/patient/medical/Akupuntur/:id',
        name: ' patient medical Akupuntur',
        component: Akupuntur,
        meta: {
          title: "Form Data Akupuntur"
        }
      },
      {
        path: '/mobile/patient/medical/birth-plan/:id',
        name: ' patient medical BirthPlan',
        component: BirthPlan,
        meta: {
          title: "Form Data Birth Plan"
        }
      },
    ]
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})